// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import { get } from 'lodash';
import * as CONSTANTS from '../../constants/index';

const initialState = {
  isLoading: false,
  error: null,
  list: {
    data: null,
  },
  enableApiPlans: {
    data: null,
  },
  createApiPlan: {
    data: null,
  },
  apiPlanDetails: {
    data: null,
  },
  updateApiPlan: {
    data: null,
  },
  updateApisForApiPlan: {
    data: null,
  },
  apisForApiPlans: {
    data: null,
  },
  orgsForApiPlans: {
    data: null,
  },
  updateOrgsForApiPlan: {
    data: null,
  },
  deleteApiPlan: {
    data: null,
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case CONSTANTS.API_PLANS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        list: {
          data: null,
        },
      };
    case CONSTANTS.API_PLANS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        list: {
          data: action.payload,
        },
      };
    case CONSTANTS.API_PLANS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        list: {
          data: null,
        },
      };

    case CONSTANTS.ENABLE_API_PLANS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        enableApiPlans: {
          data: null,
        },
      };
    case CONSTANTS.ENABLE_API_PLANS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        enableApiPlans: {
          data: action.payload,
        },
      };
    case CONSTANTS.ENABLE_API_PLANS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        enableApiPlans: {
          data: null,
        },
      };

    case CONSTANTS.FETCH_APIS_FOR_API_PLANS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        apisForApiPlans: {
          data: null,
        },
      };
    case CONSTANTS.FETCH_APIS_FOR_API_PLANS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        apisForApiPlans: {
          data: action.payload,
        },
      };
    case CONSTANTS.FETCH_APIS_FOR_API_PLANS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        apisForApiPlans: {
          data: null,
        },
      };
    case CONSTANTS.CREATE_API_PLANS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        createApiPlan: {
          data: null,
        },
      };
    case CONSTANTS.CREATE_API_PLANS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        createApiPlan: {
          data: action.payload,
        },
      };
    case CONSTANTS.CREATE_API_PLANS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        createApiPlan: {
          data: null,
        },
      };

    case CONSTANTS.FETCH_API_PLANS_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        apiPlanDetails: {
          data: null,
        },
      };
    case CONSTANTS.FETCH_API_PLANS_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        apiPlanDetails: {
          data: action.payload,
        },
      };
    case CONSTANTS.FETCH_API_PLANS_DETAILS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        apiPlanDetails: {
          data: null,
        },
      };
    case CONSTANTS.UPDATE_API_PLANS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        updateApiPlan: {
          data: null,
        },
      };
    case CONSTANTS.UPDATE_API_PLANS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        updateApiPlan: {
          data: action.payload,
        },
      };
    case CONSTANTS.UPDATE_API_PLANS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        updateApiPlan: {
          data: null,
        },
      };
    case CONSTANTS.UPDATE_APIS_FOR_API_PLANS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        updateApisForApiPlan: {
          data: action.payload,
        },
      };
    case CONSTANTS.UPDATE_APIS_FOR_API_PLANS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        updateApisForApiPlan: {
          data: null,
        },
      };
    case CONSTANTS.FETCH_ORGANIZATIONS_FOR_API_PLANS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        orgsForApiPlans: {
          data: null,
        },
      };
    case CONSTANTS.FETCH_ORGANIZATIONS_FOR_API_PLANS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        orgsForApiPlans: {
          data: action.payload,
        },
      };
    case CONSTANTS.FETCH_ORGANIZATIONS_FOR_API_PLANS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        orgsForApiPlans: {
          data: null,
        },
      };
    case CONSTANTS.UPDATE_ORGANIZATIONS_FOR_API_PLANS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        updateOrgsForApiPlan: {
          data: action.payload,
        },
      };
    case CONSTANTS.UPDATE_ORGANIZATIONS_FOR_API_PLANS_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        updateOrgsForApiPlan: {
          data: null,
        },
      };
    case CONSTANTS.DELETE_API_PLAN_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
        deleteApiPlan: {
          data: null,
        },
      };
    case CONSTANTS.DELETE_API_PLAN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        deleteApiPlan: {
          data: action.payload,
        },
      };
    case CONSTANTS.DELETE_API_PLAN_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        deleteApiPlan: {
          data: null,
        },
      };
    default:
      return state;
  }
}

export const getApiPlansList = (state) => get(state, 'apiPlans.list.data.results');
export const getApiPlansListCount = (state) => get(state, 'apiPlans.list.data.totalElements');
export const getApiPlansLoading = (state) => get(state, 'apiPlans.isLoading');
export const getApiPlansError = (state) => get(state, 'apiPlans.error[0].response.data.error.message.value');
export const getApiPlansValidationError = (state) => get(state, 'apiPlans.error');
export const getEnableApiPlansData = (state) => get(state, 'apiPlans.enableApiPlans.data');
export const getApiPlanCreateData = (state) => get(state, 'apiPlans.createApiPlan.data');
export const getApiPlanDetails = (state) => get(state, 'apiPlans.apiPlanDetails.data');
export const getUpdateApiPlanDetails = (state) => get(state, 'apiPlans.updateApiPlan.data');
export const getApisResultsForApiPlans = (state) => get(state, 'apiPlans.apisForApiPlans.data.results');
export const getTotalElementsApisForApiPlans = (state) => get(state, 'apiPlans.apisForApiPlans.data.totalElements');
export const getTotalPagesApisForApiPlans = (state) => get(state, 'apiPlans.apisForApiPlans.data.totalPages');
export const getApisUpdateForApiPlans = (state) => get(state, 'apiPlans.updateApisForApiPlan.data');
export const getOrganizationsResultsForApiPlans = (state) => get(state, 'apiPlans.orgsForApiPlans.data.results');
export const getOrganizationsTotalElementsForApiPlans = (state) => get(state, 'apiPlans.orgsForApiPlans.data.totalElements');
export const getOrganizationsTotalPagesForApiPlans = (state) => get(state, 'apiPlans.orgsForApiPlans.data.totalPages');
export const getOrgsUpdateForApiPlans = (state) => get(state, 'apiPlans.updateOrgsForApiPlan.data');
export const getDeleteApiPlan = (state) => get(state, 'apiPlans.deleteApiPlan.data');
